import { useEffect } from 'react';
import ExperienceViewClientStore from 'clientStore/ExperienceViewClientStore';
import PATH from 'routes/paths';
import { experienceId, experienceSlug } from 'routes/paths/constants';
import useInAppNavigate from './useInAppNavigate';

function useRedirectToExperienceView(): void {
  const { navigate } = useInAppNavigate();

  const localStorageExperienceId =
    ExperienceViewClientStore.getExperienceView();

  const localStorageExperienceSlug =
    ExperienceViewClientStore.getBusinessExperienceView();

  useEffect(() => {
    if (localStorageExperienceId) {
      ExperienceViewClientStore.removeExperienceView();
      navigate(
        PATH.BUSINESS.EXPERIENCE_VIEW_ONE.replace(
          experienceId,
          localStorageExperienceId
        )
      );
    }
    if (localStorageExperienceSlug) {
      ExperienceViewClientStore.removeBusinessExperienceView();
      navigate(
        PATH.BUSINESS.EXPERIENCE_VIEW_ONE.replace(
          experienceSlug,
          localStorageExperienceSlug
        )
      );
    }
  }, [localStorageExperienceId, localStorageExperienceSlug]);
}

export default useRedirectToExperienceView;
